module.exports = __webpack_public_path__ + "img/gywm.1d786286.jpg";